import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var ColumnsGridContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  width: 100%;\n"], ["\n  display: flex;\n  gap: ", ";\n  width: 100%;\n"])), function (_a) {
    var gap = _a.gap;
    return gap;
});
export var Column = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map